import { useQueryClient } from 'react-query';
import { filterNames } from '../constants/filterNames';
import { filtersData } from '../constants/filtersData';
import { getRequestsKeys } from '../queries/queryKeys';
import useFilterState from './useFilterState';

const useRequestsQueryState = () => {
  const queryClient = useQueryClient();

  const [[fromDate, toDate]] = useFilterState(
    filtersData[filterNames.createDate]
  );

  const requestsQueryState = queryClient.getQueryState(
    getRequestsKeys(fromDate, toDate)
  );

  return requestsQueryState;
};

export default useRequestsQueryState;
